import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { editPollTemplateRequested } from 'features/polls/actions';

export function* editPollTemplateSaga(action: ReturnType<typeof editPollTemplateRequested>) {
  yield call(SignalingSocket.send, { event: 'editPollTemplate', data: action.payload });
}
